/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'switch-from-to-icons': {
    width: 9,
    height: 16,
    viewBox: '0 0 9 16',
    data: '<g _fill="#3C253D" fill-rule="evenodd"><path pid="0" d="M4.494 2.408L7.9 6 9 4.739 4.494 0 0 4.739 1.1 6zM4.506 13.592L1.1 10 0 11.261 4.506 16 9 11.261 7.9 10z"/></g>'
  }
})
